import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

interface SaveAirportButtonProps {
  airportCode: string;
  isSaved: boolean;
  onToggle: (code: string) => void;
  size?: "sm" | "default" | "icon";
  className?: string;
}

export const SaveAirportButton = ({
  airportCode,
  isSaved,
  onToggle,
  size = "sm",
  className,
}: SaveAirportButtonProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      navigate("/auth");
      return;
    }
    onToggle(airportCode);
  };

  return (
    <Button
      variant="ghost"
      size={size}
      onClick={handleClick}
      className={cn(
        "gap-1.5 transition-all duration-200",
        isSaved && "text-destructive hover:text-destructive/80",
        className
      )}
      aria-label={isSaved ? `Remove ${airportCode} from saved` : `Save ${airportCode}`}
    >
      <Heart
        className={cn("h-4 w-4 transition-all", isSaved && "fill-current")}
      />
      {size !== "icon" && (isSaved ? "Saved" : "Save")}
    </Button>
  );
};
